<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>사명</h1>
                        <span>모든 사람이 영문을 쉽게 쓰도록 하는 것입니다.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="who_we_are_sections">
        <div class="container">
            <div class="row column_reverse">
                <div class="col-lg-8">
                    <div class="whot_we_are_content about_us_dots">
                        <h2>소개</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카 AI 는 학술 및 기술 텍스트에 적합하도록 설계된 차세대 문법 교정 및 언어 개선 글쓰기 보조 툴입니다. 언어 전문가, 엔지니어, 데이터 과학자로 구성된 팀이 의사소통
                            장벽 없는 미래를 열고자 하는
                            <br>깊은 열망으로 개발했습니다. 개인적 글, 학술적 글, 일상 대화에 이르기까지 모든 사람의 모든 의사소통을 도울 글쓰기 보조 툴을 구현했습니다. </p>
                        <p>트링카 AI 의 운영 주체는 이나고이고 이나고는 15년의 글로벌 경험을 축적한 다국적 기업인 크림슨 인터랙티브 주식회사 코리아 의 자회사입니다. 크림슨 인터렉티브 은 120개
                            이상의 국가에 2십만 명 이상의 고객에게 서비스를 공급하고, 600명의 직원과 5,000명의 계약 인력을 보유하고 있으며, 도쿄, 베이징, 서울, 뉴저지, 런던 등 10곳에
                            글로벌 지사를 두고 있습니다.</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="../../../assets/images/whoWeAre_aboutus.png" alt="about">
                    </div>
                </div>
            </div>

            <div class="row column_reverse prodcutName_sections">
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="../../../assets/images/TrinkaD'Cunha.jpg" alt="trinka">
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="whot_we_are_content">
                        <h2>Trinka라는 이름이 붙은 이유</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka 개발팀은 영감, 공헌, 비전의 힘을 신뢰하며, Trinka는 시작부터 결실 맺는 날까지 이 프로젝트를 이끌었던 책임 언어 전문가인 Trinka D’Cunha의 이름을
                            따서 탄생하게 되었습니다. 그녀는 효율적 지식 소통을 위해 언어 장벽을 허물겠다는 사명을 실천해 나갔습니다.</p>
                        <p>개발팀 구성원 개개인도 이 뛰어난 언어 및 문법 교정 툴을 설계하는 데 마찬가지로 중요한 역할을 했습니다. 이 혁신적인 제품은 수년간 헌신하고 창의적으로 협력해온 산물입니다.
                            각 구성원의 전문성과
                            <br> 열정이 없었다면 Trinka는 존재할 수 없었습니다.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="make_in_india_section">
        <div class="made_in_india_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="made_in_india_content">
                        <h2>Made in India</h2>
                        <div class="HeadingSubLine"></div>
                        <p>세계 무대에서 인도의 위상을 높이고 싶습니다! 인도는 정보기술 분야에서 빠른 성장으로 잘 알려져
                            <br>있으며 세계 IT 허브 중 한 곳입니다.</p>
                        <p>인도는 계속해서 빠르게 성장하고 있지만, 글로벌 대규모 시장에서 주목받는 인도 IT 제품은 드뭅니다. 개발팀은 이를 바꾸기로 결심합니다. Trinka가 그 시작입니다. 인도에서
                            완벽하게 설계하고 공학적으로 구현한 Trinka는 인공지능과 자연어 처리의 역동적인 분야에서 지속적인 인상을 남길 모든 준비가 되어 있습니다.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="made_in_india_img">
                        <img src="../../../assets/images/madeInIndia.png" alt="made-in-india">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_crimson_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="about_crimson_content">
                        <h2>크림슨인터랙티브 소개</h2>
                        <div class="HeadingSubLine"></div>
                        <p>2005년에 설립된 글로벌 기업 크림슨인터랙티브는는 연구 및 출판 솔루션 분야의 글로벌 리더이며, 연구원, 출판사, 대학, 기업이 선호하는 파트너로 인정하는 다국적 기업입니다.
                            125개 이상의 국가에 2십만 명 이상의 고객에게 서비스를 공급합니다. Crimson의 고객은 MIT, Princeton, Columbia, University of
                            Oxford 같은 유수의 대학들이 있고, 기업으로는 Toyota, Wiley, Elsevier, Capgemini, Panasonic, Fujitsu, Guinness
                            World Records, Hitachi 등이 있습니다.</p>
                        <p>크림슨인터랙티브 내에는 이나고, Ulatus, Voxtab, Trinka.ai, Enago Life Sciences, Zebra Eye 등 성공한 브랜드가 있습니다. Crimson의
                            전문 분야는 학술 출판 솔루션, e러닝, 현지화, 메디컬 커뮤니케이션, 인공지능, 미디어 솔루션 등입니다. 또한 의료 및 바이오 제약 기업의 글로벌 메디컬 커뮤니케이션
                            파트너이기도 합니다. Crimson은 도쿄, 서울, 베이징, 이스탄불, 상하이, 런던, 뉴저지, 뉴욕 등 10곳에 폭넓게 주요 글로벌 지사를 두고 있습니다.</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about_crimson_img">
                        <img src="../../../assets/images/aboutCrimson.jpg" alt="crimson">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="crimson_brand_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="crimson_brand_content">
                        <h2>브랜드</h2>
                        <div class="HeadingSubLine"></div>
                        <ul>
                            <li>
                                <a href="https://www.enago.com/" class="enago_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/enago-crimson.png" alt="enago">
                                    <div class="text_overlay">
                                        <p>Language Editing
                                            <br />Services</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.ulatus.com/" class="ulatus_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/ulatus-crimson.png" alt="ulatus">
                                    <div class="text_overlay">
                                        <p>Translation
                                            <br />Services</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.voxtab.com/" class="voxtab_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/voxtab-crimson.png" alt="voxtab">
                                    <div class="text_overlay">
                                        <p>Transcription
                                            <br />Services</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://cloud.trinka.ai/signup?_rg=KR" class="trinka_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/trinka-crimson.png" alt="trinka">
                                    <div class="text_overlay">
                                        <p>Grammar Correction &
                                            <br />Writing Assistant </p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://lifesciences.enago.com/" class="lifes_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/lifes-crimson.png" alt="lifesciences">
                                    <div class="text_overlay">
                                        <p>Medical
                                            <br />Publications</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="global_offices">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>전 세계 지사
                    </h2>
                    <div class="HeadingSubLine"></div>
                    <p>크림슨인터랙티브는 글로벌 지사를 두고 연구에 종사하시는 모든 분들을 위해 전 세계로 서비스를 제공합니다.
                    </p>
                    <div class="global-presence-wrap mart-20">
                        <div class="global-maps" style="position: relative;">
                            <div class="row">
                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap usa marr-10" id="usa" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">New Jersey,<br /> USA</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap usa padb-20" id="usaview">
                                    <div class="row">
                                        <div class="col-md-12 col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>New Jersey, USA</h3>
                                                <p class="marb-10">
                                                    <br>&nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap korea marr-20 active" id="korea" onclick="viewlocation(id)">

                                    <div class="map-box"></div>
                                    <div class="location-name">Seoul, Korea </div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap korea padb-20 show" id="koreaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Seoul, Korea</h3>
                                            <p>Crimson Interactive Korea Co., Ltd.
                                                <br> #803-74, 1-Dong, 775, Gyeongin-ro, Yeongdeungpo-gu, Seoul, Republic of Korea
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap china marr-20" id="china" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Beijing / Shanghai, China</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap china padb-20" id="chinaview">
                                    <div class="row">
                                        <div class="col-md-6  col-sm-6  col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Beijing, China</h3>
                                                <p class="marb-10">Room 607, Attempt Center, No. A6 Zhongguancun South Street, Haidian District,
                                                    Beijing, China - 100086
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6  col-sm-6 col-xs-12  global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Shangai, China</h3>
                                                <p class="marb-10">Room 101, No. 110, Tianlinshiyicun, Xuhui District, Shanghai 200233
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap japan marr-20" id="japan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Tokyo, Japan</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap japan padb-20" id="japanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Tokyo, Japan</h3>
                                            <p class="marb-10">Crimson Interactive K.K.
                                                <br> 4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo, 101-0021,
                                                Japan
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap india " id="india" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Mumbai, India</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap india padb-20 " id="indiaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Mumbai, India</h3>
                                            <p class="marb-10">Crimson Interactive
                                                <br> 1001, 10th Floor, Techniplex - II, Veer Savarkar Flyover, S. V. Road, Goregaon
                                                (W), Mumbai 400062, India
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap uk" id="uk" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">London, United Kingdom</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap uk padb-20" id="ukview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>London, United Kingdom</h3>
                                            <p class="marb-10">Woodberry House, 2 Woodberry Grove, Finchley, London, N12 0DR, United Kingdom
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap turkey" id="turkey" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Istanbul,
                                        <br />Turkey</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap turkey padb-20" id="turkeyview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Istanbul, Turkey</h3>
                                            <p class="marb-10">Levent Mah. Ulgen Sok. No:52 Besiktas Istanbul, TURKEY
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap taiwan" id="taiwan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Taipei,
                                        <br> Taiwan</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap taiwan padb-20" id="taiwanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Taipei, Taiwan</h3>
                                            <p class="marb-10">
                                                2F, No. 40, Ln 91, Sec.1,
                                                <br> Neihu Road, Neihu Dist., Taipei City 11441, Taiwan.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="no_of_glance_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="glance_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>숫자로 한눈에 보기</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="glance_contents">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/Aboutus-author.png" alt="author">
                                    </div>
                                    <p>2백만 이상의 저자</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/aboutus_satisfy.png" alt="satisfy">
                                    </div>
                                    <p>99.45%
                                        <br />고객 만족도</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/aboutus_degree_cap.png" alt="degree">
                                    </div>
                                    <p>2000명 이상의 석박사 전문가</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/globe.svg" alt="globe" style="width: 40px;">
                                    </div>
                                    <p>125개 이상의 국가에 서비스 공급</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_us_our_client">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>고객사</h2>
                    <div class="HeadingSubLine"></div>
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#UniversityPartners" role="tab">대학 파트너사</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#Corporates_sections" role="tab">기업</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="UniversityPartners" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="../../../assets/images/client_logos/Columbia_Univ_207.png" alt="Columbia">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Duke_Univ.png" alt="duke">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Priceton_Univ.png" alt="Princeton">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Purdue_Univ.png" alt="Purdue_Univ">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/MIT.png" alt="MIT">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Technical-University-of-Denmark.png" alt="TUD">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Univ_of_Birmingham.png" alt="birmingham">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Yonsei_University.png" alt="yonsei">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/University_of_Gassgow.png" alt="gassgow">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Washinton_State_Univ.png" alt="washinton">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Korea_University.png" alt="korea">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/KyotoUniversityLogo.png" alt="KU">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Peking-University.png" alt="peking">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Tsinghua_University79.png" alt="Tsinghua_University">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/University_of_Tokyo.png" alt="tokyo">
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane" id="Corporates_sections" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/wiley-logo.png" alt="wiley">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/IBMWatson-logo.png" alt="IBM Watson">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/bombay-stock.png" alt="bombay_stock">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/Netflix-logo.png" alt="netflix">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/toyota_log.png" alt="toyota">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/guiness_world_Recodos.png" alt="guiness">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/oup.png" alt="oup">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/Johnson-logo.png" alt="johnson">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/sony_logo.png" alt="sony">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/bankofjapan.png" alt="japan">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/abbott.png" alt="abbott">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/FujiTsu_logo.png" alt="Fujitsu">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/DowJones-logo.png" alt="DowJones-logo">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/canon_logo.png" alt="canon">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/pfizer-logo.png" alt="pfizer-logo">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/sanofi_logo.png" alt="sanofi">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/RBS_logo.png" alt="RBS">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/iifl-logo.png" alt="iifl">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="awards_certifications">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>수상 및 인증</h2>
                    <div class="HeadingSubLine"></div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/golden-bridge-medal.png" alt="award">
                                    </div>
                                    <p>The Golden Bridge Awards For Best Entrepreneur (Women)</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/pharma-award.png" alt="award">
                                    </div>
                                    <p>APAC CIO Outlook Top 10 Pharma & Life Science Tech Solution Providers</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/ksci.png" alt="award">
                                    </div>
                                    <p>Korea
                                        <br /> Satisfaction Consumer
                                        <br /> Index
                                    </p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/bizz-award.png" alt="award">
                                    </div>
                                    <p>Bizz Award For Business Excellence</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/qms-award.png" alt="award">
                                    </div>
                                    <p>The World Quality
                                        <br /> Commitment Award</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/red-awards.png" alt="award">
                                    </div>
                                    <p>Red Herring Top 100 Asia
                                        <br /> and Global Awards!</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/sme-award.png" alt="award">
                                    </div>
                                    <p>Google SME Award</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="our_values_slider">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>가치</h2>
                    <div class="HeadingSubLine"></div>
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>사회적 책임</h4>
                                <p>Crimson은 윤리적이고 투명한 행동으로 사회와 환경에 선한 영향을 미치며 지속 가능 개발에 기여합니다.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>존중</h4>
                                <p>존중의 가치로 문화, 사람, 환경을 대합니다. 학습자와 학습 제공자를 존중하며 이들의 기대를 충족시키기 위해 언제나 노력합니다. 겸손함과 인내의 미덕을 실천하고
                                    다양한 문화적 배경을 존중합니다.</p>
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <h4>감탄</h4>
                                <p>“감탄”이 가치 체계의 중심에 자리잡고 있습니다. 이는 모든 기대를 뛰어넘는 학습을 제공한다는 것을 의미합니다. 커뮤니케이션 향상과 혁신적 학습 제공으로 지속적인
                                    감탄을 이끌어내기 위해 노력합니다.
                                </p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>카이젠</h4>
                                <p>지속적인 개선을 뜻하는 “카이젠”의 가치가 모든 학습 제공의 핵심을 이루고 있습니다. 카이젠의 본질은 혁신인데, 기술과 인간의 노력이 지속적인 개선을 해나갈 때
                                    혁신은 일어납니다.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>혁신</h4>
                                <p>기존의 성취에 안주하지 않고 사명을 넓혀 나가는 것이 학습자의 학습을 향상시키는 일이라고 믿습니다.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>간결함</h4>
                                <p>간결함은 최첨단 기술을 활용한 간단한 프로세스를 통해 우수한 품질을 가장 효과적으로 제공하는 데 주력함을 뜻합니다. 이런 간결함을 토대로, 사용하기 쉬운 고객
                                    인터페이스, 탐색하기 쉬운 웹사이트, 명확한 서비스 약관, 맞춤형 서비스를 구현합니다. </p>
                            </div>
                        </div>

                    </div>
                    <div class="slider_background_shadow"></div>

                </div>
            </div>
        </div>
    </div>

    <div class="about_us_footer_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="footer_sections_abouts">
                        <p>빠르게 진화하는 기술의 세계, 언어가 전달하는 뉘앙스에 관심을 품고 독창적인 아이디어와 전문성을 발휘해 보고 싶나요? 바로 저희가 바라는 인재상입니다. 새로운 지평을 여는 도전에
                            함께해요!
                        </p>
                        <a href="https://www.trinka.ai/kr/workwithus" target="_blank">지원하기</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Mumbai, India",
        "postalCode": "400062",
        "streetAddress": "Office No 801, 8th Floor, Techniplex – II Off SV Road, Goregaon - West"
      },
      "email": "support@trinka.ai",
      "image": "https://www.trinka.ai/assets/images/trinka-logo.png",
      "member": [
        {
          "@type": "Organization"
        },
        {
          "@type": "Organization"
        }
      ],
      "name": "Crimson AI",
      "sameAs": [
              "https://www.facebook.com/thetrinkaai/",
              "https://www.instagram.com/thetrinkaai/",
              "https://www.linkedin.com/company/thetrinkaai"
            ]
    }
    </script>